const PbxxRecord = require('../../pbxx_record')

module.exports = class BrandRequestMetrics extends PbxxRecord {
  static get class_name() {
    return 'BrandRequestMetrics'
  }
}
